var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_707_",
    d: "M88.5,12.5c-0.1-0.1-0.1-0.1-0.2-0.2L77.5,2.9C76,1.5,74,0.8,71.8,1c-1.9,0.2-3.8,1-5.2,2.4 c-0.1,0.1-0.2,0.2-0.3,0.3L55.7,17.1c-2.8,3-2.7,7.6,0.2,10.5c0.2,0.2,0.4,0.4,0.6,0.5l5.4,3.6c-0.4,1.9-3.2,7.3-13.1,17.2 C39,58.7,33.5,61.5,31.7,61.9l-3.6-5.4c-0.1-0.2-0.3-0.4-0.5-0.6C24.7,53,20,53,17.1,55.7L3.8,66.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-3,3-3.2,8-0.5,10.9l9.4,10.7c0.1,0.1,0.1,0.1,0.2,0.2c1.8,1.8,4.6,2.5,7.7,2.5c5.5,0,11.8-2.2,15.1-3.5c6.4-2.5,18.9-8.6,31.3-21 c9.2-9.2,16.6-20.3,21-31.3C89.5,30.1,93.7,17.7,88.5,12.5z M60.9,60.9C42.4,79.4,21.6,84.5,18.1,82.8L9,72.3c0,0,0,0,0,0l13-10.3 l3.5,5.3c0.1,0.1,0.1,0.2,0.2,0.3c1.2,1.5,2.9,2.3,4.9,2.4c1.9,0.1,7.8,0.4,23.7-15.5c3.9-3.9,15.9-15.9,15.5-23.7 c-0.1-2-1-3.7-2.4-4.9c-0.1-0.1-0.2-0.2-0.3-0.2L62,22.1L72.3,9c0,0,0,0,0,0l10.4,9.1C84.5,21.6,79.4,42.4,60.9,60.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.37c6b6d7e12dca44eba3241985db6e2c.svg";
export { ForwardRef as ReactComponent };